<template>
  <div>
    <div class="w-full space-y-6">
      <h2 class="font-serif text-3xl font-bold text-center text-gray-900">Forgot Password</h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="tel"
          placeholder="Contact Number"
          v-model="contact"
          required
          maxlength="15"
          class="form-input"
        />
        <button
          type="submit"
          class="btn-cream w-full py-3"
        >
          Send Reset OTP
        </button>
      </form>

      <button @click="$emit('switch','login')" class="text-brand-red font-medium hover:underline text-sm w-full text-center">
        Back to Login
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const emit = defineEmits(["success","error","switch"]);

const contact = ref("");
const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

const submit = async () => {
  let cleanedContact = contact.value.replace(/\D/g,''); // remove non-digit chars
  
  // Handle country code cases (e.g. 919876543210 -> 9876543210)
  if (cleanedContact.length > 10) {
    if (cleanedContact.startsWith('91') && cleanedContact.length === 12) {
      cleanedContact = cleanedContact.substring(2);
    } else if (cleanedContact.startsWith('0') && cleanedContact.length === 11) {
      cleanedContact = cleanedContact.substring(1);
    }
  }

  if (cleanedContact.length !== 10) {
    return emit("error", "Enter a valid 10-digit phone number");
  }

  try {
    const res = await fetch(`${baseUrl}/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contact: cleanedContact }), // <-- send as contact
    });
    const data = await res.json();
    if (!res.ok) return emit("error", data.error || "Failed to send OTP!");
    emit("success","OTP sent!");
    sessionStorage.setItem("resetContact", cleanedContact);
    emit("switch","otp");
  } catch {
    emit("error","Connection error");
  }
};
</script>
